import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import axios from 'axios';

const QRLandingPage: React.FC = () => {
  const { cafeId } = useParams<{ cafeId: string }>();

  useEffect(() => {
    const recordScanAndRedirect = async () => {
      try {
        // Record QR scan (non-blocking) - Sadece cafeId gönder
        axios.post(`https://api.sobcof.com/api/qr-scan/${cafeId}`)
          .catch(err => console.error('QR scan recording failed:', err));

        // Immediate redirect after 1 second
        setTimeout(() => {
          window.location.href = 'https://apps.apple.com/tr/app/sobcof/id6751366978?l=tr';
        }, 1000);
      } catch (error) {
        console.error('Error:', error);
        // Redirect anyway
        setTimeout(() => {
          window.location.href = 'https://apps.apple.com/tr/app/sobcof/id6751366978?l=tr';
        }, 1000);
      }
    };

    if (cafeId) {
      recordScanAndRedirect();
    }
  }, [cafeId]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #8B4513 0%, #D2691E 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          animation: 'fadeIn 0.5s ease-in'
        }}
      >
        {/* App Name */}
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            color: 'white',
            mb: 3,
            fontSize: { xs: '3rem', sm: '4rem' },
            textShadow: '0 4px 20px rgba(0,0,0,0.3)',
            letterSpacing: '3px'
          }}
        >
          SobCof
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="h6"
          sx={{
            color: 'rgba(255,255,255,0.95)',
            mb: 4,
            fontWeight: 400,
            fontSize: { xs: '1rem', sm: '1.25rem' }
          }}
        >
          Kahvede Tanış, Arkadaş Ol
        </Typography>

        {/* Loading Spinner */}
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: 'white',
            mb: 3
          }}
        />

        {/* Redirect Text */}
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255,255,255,0.9)',
            fontSize: '1.1rem',
            fontWeight: 500
          }}
        >
          App Store'a yönlendiriliyorsunuz...
        </Typography>

        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
          `}
        </style>
      </Box>
    </Box>
  );
};

export default QRLandingPage;
